import { render, staticRenderFns } from "./admin-call-markaz-show.vue?vue&type=template&id=280c70a9&scoped=true"
import script from "./admin-call-markaz-show.vue?vue&type=script&lang=js"
export * from "./admin-call-markaz-show.vue?vue&type=script&lang=js"
import style0 from "./admin-call-markaz-show.vue?vue&type=style&index=0&id=280c70a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c70a9",
  null
  
)

export default component.exports